import React, { Component } from 'react';

import { Document, Page } from 'react-pdf/dist/entry.webpack';

require(`../assets/${process.env.PAGE}/css/components/pdf-body.css`)

class PdfBody extends Component {

  constructor(props) {
    super(props);

    this.state = {
      numPages: null,
      pageNumber: 1,
    }

    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    this.changePage = this.changePage.bind(this);
  }

  onDocumentLoadSuccess({ numPages }) {
    this.setState({numPages: numPages});
  }

  changePage(page){
    this.setState({ pageNumber: page });
  }

  render() {
    const { urlFile } = this.props;
    const { pageNumber, numPages } = this.state;

    return (
      <div className="pdf-body">
        <Document
          className="pdf-body-document"
          file={urlFile}
          onLoadSuccess={this.onDocumentLoadSuccess}
        >
          <Page pageNumber={pageNumber} />
        </Document>
        <div className="pdf-body-page-control">
          <button disabled={((pageNumber - 1) < 1)} type="button" onClick={() => this.changePage(pageNumber - 1)}>‹</button>
          <span>{pageNumber} de {numPages}</span>
          <button disabled={((pageNumber + 1) > numPages)} type="button" onClick={() => this.changePage(pageNumber + 1)}>›</button>
        </div>
        {/*(<div className="pdf-body-download-link">
          <a href={"urlFile"} target="_blank">Visualizar en una ventana nueva</a>
    </div>)*/}
      </div>

    );
  }

}

export default PdfBody;


/** WEBPACK FOOTER **
 ** ./src/components/PdfBody.js
 **/